import { useLayoutEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from "store/hooks";
import { logout } from "store/slices/userSlides";
import { logout as sessionLogout } from 'utils/Session';

const Logout = () => {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    async function logoutAndNavigateToLogin() {
      await sessionLogout();
      dispatch(logout());
      await navigate("/auth/login");
    }
    logoutAndNavigateToLogin();
  })
  return (
    <></>
  );
}

export default Logout;
